var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-roll-wrap"},[_c('span',{staticClass:"prefix"},[_vm._v(_vm._s(_vm.prefix))]),_c('span',{ref:"number",staticClass:"number-roll"}),(_vm.hasFloat)?_c('span',[_vm._v(".")]):_vm._e(),_c('span',{ref:"float",staticClass:"number-roll"}),_c('span',{staticClass:"suffix"},[_vm._v(_vm._s(_vm.suffix))])])
}
var staticRenderFns = []

export { render, staticRenderFns }